/**
 * It takes an array of objects and reduces it so there is only one occurrence of each object with the same key-value pairs.
 * This util is relevant: spreading a set in an array does the job for primitive values, but doesn't for objects as their own reference makes them unique.
 * @param array An array of objects
 * @return An array of objects without duplicates
 */
export const removeDuplicateObjects = (array: any[]): any[] =>
  array.reduce((acc, currentObject) => {
    const isDuplicate = acc.some((existingObject: any) =>
      Object.entries(existingObject).every(([key, value]) => currentObject[key] === value)
    )

    if (!isDuplicate) acc.push(currentObject)

    return acc
  }, [])

/**
 * @param count How many copies of an item you want
 * @param item It could be a string, number, object... anything really
 * @return An array of repeated items
 */
export const repeatItemInArray = <T = unknown>({ count, item }: { count: number; item: T }): T[] => {
  const resultArray = []

  for (let i = 0; i < count; i++) {
    resultArray.push(item)
  }

  return resultArray
}
